/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { makeStyles } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getCctv, getCctvTios, postCctv, putCctv } from "../../../../services";

const useStyles = makeStyles(() => ({
  textField: {
    marginBottom: 16,
    minWidth: 350,
  },
}));

const initForm = {
  id: "",
  group_id: "",
  name: "",
  description: "",
};

const FormCctv = ({ action, data, onCancel, refreshTable }: any) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [formState, setFormState] = useState<any>(data || initForm);
  const [cctvTios, setCctvTios] = useState<any>([]);
  const [groupCctv, setGroupCctv] = useState("");
  const editData = cctvTios.find(
    (row: any) => row.group_id === formState.group_id
  );

  const handleChangeForm = (event: any) => {
    setFormState({ ...formState, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      let res;
      if (action === "add") res = await postCctv(formState);
      if (action === "edit") {
        res = await putCctv(data.id, {
          id: formState.id,
          group_id: formState.group_id,
          name: formState.name,
          description: formState.description,
        });
      }
      if (res.status === "success") {
        onCancel();
        refreshTable();
      }
      enqueueSnackbar(res.message, { variant: res.status });
    } catch (err: any) {
      enqueueSnackbar(err.message, { variant: "error" });
    }
  };

  const fetchCctv = async () => {
    try {
      const resCctvTios = await getCctvTios();
      const resCctvDirector = await getCctv(100, 1);
      const cctvFiltered = resCctvTios.data.filter(
        (elem: any) =>
          !resCctvDirector.data.rows.find(({ id }: any) => elem.id === id)
      );
      setCctvTios(cctvFiltered);
    } catch (err: any) {
      enqueueSnackbar(err.message, { variant: "error" });
    }
  };

  useEffect(() => {
    fetchCctv();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      {action === "add" && (
        <>
          <Autocomplete
            id="group-name"
            className={classes.textField}
            options={cctvTios.filter(
              (v: any, i: number, a: any) =>
                a.findIndex((t: any) => t.group_name === v.group_name) === i
            )}
            getOptionLabel={(option: any) => option.group_name}
            renderInput={(params) => (
              <TextField {...params} label="Group Name" variant="outlined" />
            )}
            onChange={(event, newValue) => {
              setGroupCctv(newValue?.group_name);
              setFormState({ ...formState, group_id: newValue?.group_id });
            }}
          />
          <Autocomplete
            id="name"
            className={classes.textField}
            options={cctvTios.filter(
              (row: any) => row.group_name === groupCctv
            )}
            getOptionLabel={(option: any) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Name" variant="outlined" />
            )}
            onChange={(event, newValue: any) => {
              setFormState({
                ...formState,
                id: newValue?.id,
                name: newValue?.name,
              });
            }}
          />
        </>
      )}
      {action === "edit" && editData && (
        <>
          <TextField
            fullWidth
            disabled
            id="outlined-read-only-input"
            label="Group Name"
            className={classes.textField}
            defaultValue={editData?.group_name}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
          />
          <TextField
            fullWidth
            disabled
            id="outlined-read-only-input"
            label="Name"
            className={classes.textField}
            defaultValue={editData?.name}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
          />
        </>
      )}
      <TextField
        required
        fullWidth
        variant="outlined"
        id="description"
        label="Description"
        name="description"
        className={classes.textField}
        value={formState.description}
        onChange={handleChangeForm}
      />
      <div
        style={{
          margin: "16px 0",
          display: "flex",
          gap: 16,
          justifyContent: "flex-end",
        }}
      >
        <Button variant="contained" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </div>
    </form>
  );
};

FormCctv.propTypes = {
  action: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  refreshTable: PropTypes.func.isRequired,
  data: PropTypes.objectOf,
};

FormCctv.defaultProps = {
  data: null,
};

export default FormCctv;
